// Renderiza títulos de seção com trechos em fonte manuscrita.
// Convenção do editor: o texto entre *asteriscos* vira destaque manuscrito.
export function renderScriptTitle(text, scriptClass) {
  const parts = String(text || "").split(/(\*[^*]+\*)/g).filter(Boolean);
  if (!parts.length) return null;
  return parts.map((p, i) =>
    p.length > 1 && p.startsWith("*") && p.endsWith("*")
      ? <span key={i} className={scriptClass}>{p.slice(1, -1)}</span>
      : <span key={i}>{p}</span>
  );
}
